<template>
	<div class="half_1_2">
		<div class="white_block_space white-block">

			<!--header of widget-->
			<div class="patient-info-title wg_title">
				<div class="sched_plus" @click="addNewRecord"></div>
				<p>Сахар</p>
			</div>

			<!--list of current records-->
			<div class="patient-form cont_wg" v-if="!newRecord">
				<div class="patient-form-block pat_wg_box" v-for="item in bloodSugar">
					<div class="formButton list" @click="selectRecord(item)">
						{{item.value}} ммоль/л
					</div>
				</div>

				<div class="no_records_wg" v-if="!bloodSugar.length">
					Еще не было добавлено записей в эту категорию
				</div>
			</div>

			<!--new record -->
			<div class="patient-form cont_wg" v-if="newRecord">
				<div class="patient-form-block pat_wg_box">
					<div class="list title">
						Добавить показание
					</div>

					<div class="list">
						<div class="timer" @click="showTimePicker">
							{{(time.hour <= 9) ? '0' + time.hour : time.hour}}:{{(time.minute <= 9) ? '0' + time.minute : time.minute}}
							{{[time.day, 'DD-MM-YYYY'] | moment('DD MM YYYY')}}
						</div>
					</div>

					<div class="list">
						<div class="icon_button" :class="{'active': icon == 'morning'}" @click="selectIcon('morning')">Утром</div>
						<div class="icon_button" :class="{'active': icon == 'before'}" @click="selectIcon('before')">До еды</div>
						<div class="icon_button" :class="{'active': icon == 'after'}" @click="selectIcon('after')">После еды</div>
						<div class="icon_button" :class="{'active': icon == 'evening'}" @click="selectIcon('evening')">Вечером</div>
					</div>
				</div>

				<div class="list value">
					<input type="text" title="value" v-model="value[0]"> , <input type="text" title="value" v-model="value[1]">
					<div class="units">Ммоль/л</div>
				</div>

				<div class="list action_buttons">
					<button class="button cancel" @click="cancelNew('cancel')">Отмена</button>
					<button class="button approve" @click="cancelNew('approve')">Сохранить</button>
				</div>
			</div>

			<!--time modal-->
			<div class="time_modal" v-if="showModal">
				<div id="datepicker"></div>

				<div class="time_input_blocks">
					<div class="hour">
						<div class="up" @click="increase('hour')">up</div>
						<input title="hour" type="number" v-model="time.hour" max="24" min="0">
						<div class="down" @click="decrease('hour')">down</div>
					</div>
					<div class="minute">
						<div class="up" @click="increase('minute')">up</div>
						<input title="hour" type="number" v-model="time.minute" min="0" max="60">
						<div class="down" @click="decrease('minute')">down</div>
					</div>
				</div>

				<div class="action_buttons">
					<button class="button cancel" @click="closeModal('cancel')">Отмена</button>
					<button class="button approve" @click="closeModal('approve')">Выбрать</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import moment from 'moment'

	export default {
		name: "BloodSugar",
		computed: {
			userId() {
				if (this.$route.query.patient) {
					return this.$route.query.patient
				}

				return this.$storage.get('user')
			},
			workerId() {
				return this.$route.query.doctor
			}
		},
		mounted(){
			this.getRecords()
		},
		data() {
			return {
				bloodSugar: [],
				newRecord: false,
				showModal: false,
				icon: '',
				time: {
					day: '' || moment().format('DD-MM-YYYY'),
					hour: 0,
					minute: 0
				},
				value: [],
				selectRecord: this.$parent.selectRecord
			}
		},
		methods: {
			getRecords() {
				this.$api.post('card/list', {
					type: "blood_sugar",
					worker_id: this.workerId,
					user_id: this.userId
				}).then(response => {
					this.bloodSugar = response
				})
			},
			addNewRecord() {
				this.newRecord = true
			},
			selectIcon(icon) {
				this.icon = icon
			},
			showTimePicker() {
				this.showModal = true
			},
			increase(type) {
				if (type === 'hour' && this.time.hour < 24) {
					this.time.hour++
				} else if (this.time.minute < 60) {
					this.time.minute++
				}
			},
			decrease(type) {
				if (type === 'hour' && this.time.hour > 0) {
					this.time.hour--
				} else if (this.time.minute > 0) {
					this.time.minute--
				}
			},
			closeModal(command) {
				if (command !== 'approve') {
					this.time.day = moment().format('DD-MM-YYYY')
					this.time.hour = 0
					this.time.minute = 0
				}
				this.showModal = false
			},
			cancelNew(command) {
				if (command === 'approve') {
					if (!this.time.day || !this.value || !this.icon) {
						this.$event.toast('i', "Заполните все поля")
						return false
					}

					let value = (this.value[0] || 0) + ',' + (this.value[1] || 0)

					this.$store.dispatch('card/create', {
						day: this.time.day,
						time: this.time.hour + ':' + this.time.minute,
						icon: this.icon,
						value: value,
						user_id: this.userId,
						worker_id: this.workerId,
						type: "blood_sugar"
					}).then(this.getRecords)
				}

				this.newRecord = false
			},
			onSelect(date) {
				this.time.day = date
			}
		}
	}
</script>

<style lang="scss" scoped>
	.list {
		text-align: center;

		&.title {
			font-weight: 700;
		}

		.icon_button {
			display: inline-block;
			width: 45%;
			padding: 5px 0;

			&:nth-child(2n) {
				clear: both;
			}

			&:hover {
				background: #00c300;
				color: #565656;
				cursor: pointer;
			}

			&.active {
				color: #00c300;

				&:hover {
					color: #565656;
				}
			}
		}

		&.value {
			& > input {
				width: 40%;
			}
		}

		&.action_buttons {
			margin-top: 50px;
			text-align: center;
			width: 100%;

			& > .button {
				display: inline-block;
				border: none;
				border-radius: 10px;
				height: 35px;
				outline: none;

				&:hover {
					cursor: pointer;
				}

				&.cancel {
					&:hover {
						background: #ff6140;
					}
				}

				&.approve {
					&:hover {
						background: #4eff82;
					}
				}
			}
		}
	}

	.timer {
		cursor: pointer;
		color: #4fb2ff;
		padding: 5px 0;

		&:hover {
			text-decoration: underline;
		}
	}

	.time_modal {
		position: fixed;
		top: 20%;
		left: 30%;
		transform: translate(50% 50%);
		padding: 5px;
		border: 1px solid grey;
		background: white;

		& > .action_buttons {
			text-align: center;
			width: 100%;

			& > .button {
				display: inline-block;
				width: 30%;
				border: none;
				border-radius: 10px;
				height: 35px;
				outline: none;

				&:hover {
					cursor: pointer;
				}

				&:first-child {
					margin-right: 30px;
				}

				&.cancel {
					&:hover {
						background: #ff6140;
					}
				}

				&.approve {
					&:hover {
						background: #4eff82;
					}
				}
			}

		}
	}

	.time_input_blocks {
		width: 100%;

		& > .hour {
			text-align: center;
			display: inline-block;
			width: 49%;
		}
		& > .minute {
			text-align: center;
			display: inline-block;
			width: 49%;
		}
	}

	.up, .down {
		cursor: pointer;
		padding: 3px 2px;
		-webkit-user-select: none; /* webkit (safari, chrome) browsers */
		-moz-user-select: none; /* mozilla browsers */
		-ms-user-select: none; /* IE10+ */

		&:hover {
			color: grey;
		}
	}

	.formButton {
		background: #dfdfdf;

		&:hover {
			background: #0DA4A9;
			color: #fff;
		}
	}
</style>



// WEBPACK FOOTER //
// BloodSugar.vue?34768592